/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ agent: NonNullable<unknown> }} Audit_Details_Agent_Created_DescInputs */



/**
* | output |
* | --- |
* | "The agent \"{agent}\" was created." |
*
* @param {Audit_Details_Agent_Created_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_agent_created_desc = /** @type {((inputs: Audit_Details_Agent_Created_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Agent_Created_DescInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Der Agent "${i?.agent}" wurde erstellt.`)
	return /** @type {LocalizedString} */ (`The agent "${i?.agent}" was created.`)
});